export default __webpack_public_path__ + "static/media/twitter.71a78233.svg";